// extracted by mini-css-extract-plugin
var _1 = "ra-box-active";
var _2 = "ra-boxes";
var _3 = "ra-boxes-wrap";
export { _1 as "boxActiveCls", _2 as "boxesCls", _3 as "boxesWrapCls" }
